import React, { lazy, Suspense, useEffect, useState } from 'react';
import Footer from '../section/footer/footer';
import { APP_FLOW } from '../common/constant';
import Header from '../section/header/header';
import { QUEUE_FIDYAH_ICON, QUEUE_ZAKAT_ICON } from '../common/images-s3';
import ImageLoader from '../common/image-loader';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import * as userAction from '../redux/actions/userAction';
import * as zakatCalc from '../redux/actions/zakatCalcAction';
import * as zakat from '../redux/actions/zakatActions';
import { getAppFlow } from '../views/utils/app.utils';
import { fidyahActions } from '../redux/reducers/fidyah-slice';

export const questionnAireHeaderData = {
    title: 'Questionnaire',
    subTitle: 'Next - Select an option',
    steps: 2
}


const ContributionType = ({ setHeaderData }) => {
    const [isSkipButtonVisible, setIsSkipButtonVisible] = useState(false);
    const appFlow = getAppFlow()
    const dispatch = useDispatch()
    const homepageData = useSelector((state) => state.homepageReducer);
    const options = [{
        title: 'Zakat Harta',
        cardTitle: "Savings, Gold, Insurance, Shares, Business and Fitrah",
        id: 13,
        iconUrl: QUEUE_ZAKAT_ICON,
        isEnabled: homepageData?.appPreferences?.map(preference => preference.title).includes("Zakat Harta") && Boolean(homepageData?.muisZakatHarta)
    },
    {
        title: 'Fidyah',
        cardTitle: "Payment for a person's missed fasts during past Ramadan",
        id: 14,
        iconUrl: QUEUE_FIDYAH_ICON,
        isEnabled: homepageData?.appPreferences?.map(preference => preference.title).includes("Fidyah") && Boolean(homepageData?.muisZakatFidyah)
    }
    ]

    const [selectedContribution, setSelectedContribution] = useState({
        title: '',
        id: 0,
        iconUrl: '',
    })

    console.log(appFlow, 'appFllow', selectedContribution)
    const handleNext = () => {

        setHeaderData(questionnAireHeaderData)
        dispatch(userAction.updateUserSteps(questionnAireHeaderData))
    }

    const handleContributionType = (value) => {
        if (value.title === 'Zakat Harta') {
            sessionStorage.setItem("flowType", APP_FLOW.ZAKAT);
        }
        else {
            sessionStorage.setItem("flowType", APP_FLOW.FIDYAH);
        }
        setSelectedContribution(value)
    }

    const handleSkip = () => {

    }

    useEffect(() => {
        if (appFlow === APP_FLOW.ZAKAT) {
            console.log('called');
            setSelectedContribution(options[0]);
            dispatch(fidyahActions.reset());
        }
        else if (appFlow === APP_FLOW.FIDYAH) {
            setSelectedContribution(options[1]);
            dispatch(zakatCalc.resetZakatCalcData());
            dispatch(zakat.resetZakatData());
        }
        dispatch(userAction.resetUserDataExceptSteps());
    }, []);



    return (
        <>
            <div className='flow-view'>
                <div className='cards-block contribution-type-pg'>
                    {
                        options.map((value, index) => {
                            if (!value.isEnabled) return null;
                            return (
                                <>
                                    <div key={index} className={`common-card  ${selectedContribution.id === value.id ? 'active' : ''}`} onClick={() => handleContributionType(value)}>
                                        <div className='card-left'>
                                            <div className='card-icon'>
                                                <ImageLoader type="image" src={value.iconUrl}> </ImageLoader>
                                            </div>
                                            <div className='card-content'>
                                                <h4>{value.title}</h4>
                                                {value.cardTitle ? <h6>{value.cardTitle}</h6> : null}
                                            </div>
                                        </div>
                                        <div className='card-right custom-radio'>
                                            <input type="radio" id={value.id} defaultChecked={selectedContribution.id === value.id} checked={selectedContribution.id === value.id} />
                                        </div>
                                    </div>
                                </>
                            )
                        })
                    }

                </div>
            </div>
            <Footer isSkipButtonVisible={isSkipButtonVisible} handleNext={handleNext} handleSkip={handleSkip} disabled={!selectedContribution.id} />
        </>
    );
};

export default ContributionType;
